var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResourceActivity = function SvgResourceActivity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ac2f5830-921b-4800-b296-0f0aba7b6131",
    "data-name": "Layer 1",
    viewBox: "0 0 128 128",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b839db06-d0de-48c2-9744-c496334404f3",
    "data-name": "activity"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "b6146817-c954-40d4-be5d-34252d6eed9c",
    "data-name": "Rectangle",
    width: 128,
    height: 128,
    style: {
      fill: "#84cfec",
      fillOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "b370037f-110f-45cd-af36-ec4122b99561",
    "data-name": "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "becf714a-1853-4b6c-bc9e-0e0bf64b0406",
    "data-name": "Path",
    d: "M94.49322,31a8.8783,8.8783,0,0,1,8.864,8.60639l.00379.26106V89.03053a8.87825,8.87825,0,0,1-8.60655,8.86366l-.261.00379H32.8676a8.87816,8.87816,0,0,1-8.86381-8.6064L24,89.03053V39.86745a8.87815,8.87815,0,0,1,8.60655-8.86366L32.8676,31Z",
    style: {
      fill: "#a0b3be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a11a062c-362e-460b-8c04-cddb257b33c3",
    "data-name": "Path",
    d: "M94.49322,34H32.8676a5.8783,5.8783,0,0,0-5.86354,5.648L27,39.86745V89.03053a5.87828,5.87828,0,0,0,5.64814,5.86339l.21946.00406H94.49338a5.87841,5.87841,0,0,0,5.86354-5.648l.00406-.21945V39.86745a5.87842,5.87842,0,0,0-5.64829-5.86339Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "f14fafc7-889e-46c8-8e57-a4f39d2c31aa",
    "data-name": "Path",
    d: "M94.49322,34H32.8676a5.8783,5.8783,0,0,0-5.86354,5.648L27,39.86745v3.82607h73.361V39.86745a5.87842,5.87842,0,0,0-5.64829-5.86339Z",
    style: {
      fill: "#84cfec"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "be65dc2a-d384-4e8c-89d6-3d7fd8cab2f1",
    "data-name": "Line",
    points: "93 53 93 57 60 57 60 53 93 53",
    style: {
      fill: "#a0b3be"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "b6bea553-77df-40af-bc21-5afbf659a86d",
    "data-name": "Line-Copy-3",
    points: "93 62 93 66 60 66 60 62 93 62",
    style: {
      fill: "#a0b3be"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e28cc733-571a-4baf-9ed1-518eaae3ff38",
    "data-name": "Rectangle",
    x: 35,
    y: 53,
    width: 19,
    height: 13,
    style: {
      fill: "#84cfec"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "be4f6ea8-e679-41cd-9181-e8470689e53c",
    "data-name": "Line-Copy",
    points: "93 72 93 76 35 76 35 72 93 72",
    style: {
      fill: "#a0b3be"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "ec262527-2683-4c87-91d6-79016026fc59",
    "data-name": "Line-Copy-2",
    points: "93 81 93 85 35 85 35 81 93 81",
    style: {
      fill: "#a0b3be"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResourceActivity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resource_activity.58558e63.svg";
export { ForwardRef as ReactComponent };